export const units = ["pixels", "inch", "cm", "mm"] as const;
export type Unit = typeof units[number];
